import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { PI } from '../../constants-types';
import { UserProfileRequest, UserProfileResponse } from '../../core-data-model';
import { UpdateUserLanguageRequest } from '../../core-data-model/update-user-language-request';
import { UserAccessResponse } from '../../core-data-model/user-access-response';
import {
    InitDataService,
    UserProfileSettingsService
} from '../../system-services';

@Injectable({
    providedIn: 'root'
})
export class UserProfileApi {
    constructor(
        private readonly http: HttpClient,
        private readonly userProfile: UserProfileSettingsService,
        private readonly initDataService: InitDataService
    ) {}

    getUserProfileInfo(): Observable<UserProfileRequest> {
        return this.http
            .get<UserProfileResponse>(this.userProfileApiEndpoint('profile'))
            .pipe(map((res) => res.response));
    }

    updateUserProfileInfo(
        request: UserProfileRequest
    ): Observable<UserProfileRequest> {
        const url = this.userProfileApiEndpoint('info');
        return this.http.patch<UserProfileRequest>(url, request);
    }

    updateUserLanguage(
        request: UpdateUserLanguageRequest
    ): Observable<UserAccessResponse> {
        return this.http.put<UserAccessResponse>(
            this.userProfileApiEndpoint('update-language', true),
            request
        );
    }

    private userProfileApiEndpoint(
        endpoint: string,
        useBaseCompany: boolean = false
    ): string {
        const companyGuid = useBaseCompany
            ? this.initDataService.user.companyId
            : this.userProfile.currentCompany;
        const userProfileApiPrefix = `api/v1/companies/${companyGuid}/users/${this.userProfile.myUserId}`;

        let baseApi = PI?.appSettings?.userApiUrl ?? '';
        baseApi = baseApi.replace(/\/$/, '').concat('/');
        endpoint = endpoint.replace(/(^\/{0,2})|(\/{0,2}$)/g, '');

        return baseApi.concat(`${userProfileApiPrefix}/${endpoint}`);
    }
}
